import axios, { AxiosInstance } from "axios";
import router from "../router";
export default (): AxiosInstance => {
  const __API__ = `${process.env.VUE_APP_ROOT_API}`;
  const instance = axios.create({
    baseURL: __API__,
    headers: {
      'Content-Type': 'application/json'
    }
  });
  instance.defaults.withCredentials = true;
  instance.interceptors.response.use(response => {
    return response;
  }, error =>{
    if (error.message === "Request failed with status code 404") {
      router.replace({path: "/expired"});
    }else if (error.response.status == 401) {
      router.replace({path: "/expired"});
    }
    return Promise.reject(error.response);
  })
  return instance;
};
